// Idiomas SOB DEMANDA.
//
// O `i18n/index.js` importa os 43 idiomas de uma vez. Isso joga todos eles no mesmo
// pedaço do bundle: 18 MB para o navegador interpretar (5 MB no cabo) para o usuário
// usar UM. Em conexão de cliente comum vira vários segundos de tela branca no
// primeiro acesso.
//
// Aqui cada idioma é um `import()` próprio — o Vite gera um arquivo por idioma e só
// o escolhido desce. O inglês continua embutido: é o fallback do vue-i18n e precisa
// estar pronto antes de qualquer tela pintar.
//
// O mapa é ESCRITO À MÃO de propósito. Varrer a pasta com `import.meta.glob` parece
// mais limpo, mas locale/ tem 57 diretórios e 14 estão incompletos (o `zh`, por
// exemplo, tem index.js sem os JSONs) — o Chatwoot nunca os importou, e tentar
// resolvê-los quebra o build. Ao adicionar um idioma novo, some aqui e no index.js.
import en from './locale/en';

const carregadores = {
  ar: () => import('./locale/ar/index.js'),
  bg: () => import('./locale/bg/index.js'),
  ca: () => import('./locale/ca/index.js'),
  cs: () => import('./locale/cs/index.js'),
  da: () => import('./locale/da/index.js'),
  de: () => import('./locale/de/index.js'),
  el: () => import('./locale/el/index.js'),
  es: () => import('./locale/es/index.js'),
  et: () => import('./locale/et/index.js'),
  fa: () => import('./locale/fa/index.js'),
  fi: () => import('./locale/fi/index.js'),
  fr: () => import('./locale/fr/index.js'),
  he: () => import('./locale/he/index.js'),
  hi: () => import('./locale/hi/index.js'),
  hu: () => import('./locale/hu/index.js'),
  id: () => import('./locale/id/index.js'),
  is: () => import('./locale/is/index.js'),
  it: () => import('./locale/it/index.js'),
  ja: () => import('./locale/ja/index.js'),
  ko: () => import('./locale/ko/index.js'),
  lt: () => import('./locale/lt/index.js'),
  lv: () => import('./locale/lv/index.js'),
  ml: () => import('./locale/ml/index.js'),
  nl: () => import('./locale/nl/index.js'),
  no: () => import('./locale/no/index.js'),
  pl: () => import('./locale/pl/index.js'),
  pt: () => import('./locale/pt/index.js'),
  pt_BR: () => import('./locale/pt_BR/index.js'),
  ro: () => import('./locale/ro/index.js'),
  ru: () => import('./locale/ru/index.js'),
  sk: () => import('./locale/sk/index.js'),
  sl: () => import('./locale/sl/index.js'),
  sr: () => import('./locale/sr/index.js'),
  sv: () => import('./locale/sv/index.js'),
  ta: () => import('./locale/ta/index.js'),
  th: () => import('./locale/th/index.js'),
  tr: () => import('./locale/tr/index.js'),
  uk: () => import('./locale/uk/index.js'),
  uz: () => import('./locale/uz/index.js'),
  vi: () => import('./locale/vi/index.js'),
  zh_CN: () => import('./locale/zh_CN/index.js'),
  zh_TW: () => import('./locale/zh_TW/index.js'),
};

export const IDIOMAS_DISPONIVEIS = ['en', ...Object.keys(carregadores)].sort();

export const mensagensIniciais = { en };

const jaCarregados = new Set(['en']);

// Carrega o idioma e o registra no i18n. Devolve true se ficou pronto para uso.
export const carregarIdioma = async (i18n, codigo) => {
  if (!codigo || jaCarregados.has(codigo)) return true;

  const carregar = carregadores[codigo];
  if (!carregar) return false;

  try {
    const mod = await carregar();
    i18n.global.setLocaleMessage(codigo, mod.default || mod);
    jaCarregados.add(codigo);
    return true;
  } catch (e) {
    // idioma indisponível não pode derrubar a aplicação: fica no fallback
    return false;
  }
};

// A instância criada no entrypoint. Guardar aqui em vez de receber `$i18n` do
// componente é de propósito: o `$i18n` de um componente pode ser um composer
// LOCAL, e trocar o idioma nele não muda a aplicação — foi o que fez a tela
// continuar em inglês depois do login (que não recarrega a página, então o idioma
// do HTML ainda era o da tela de login, sem usuário).
let instancia = null;

export const registrarI18n = i18n => {
  instancia = i18n;
};

const definirIdioma = codigo => {
  const alvo = instancia?.global;
  if (!alvo) return;
  if (typeof alvo.locale === 'object' && 'value' in alvo.locale) {
    alvo.locale.value = codigo;
  } else {
    alvo.locale = codigo;
  }
};

// Troca o idioma ativo, carregando antes se preciso. Só troca DEPOIS que as
// mensagens estão lá — trocar antes deixaria a tela mostrando as chaves cruas.
export const aplicarIdioma = async codigo => {
  if (!codigo || !instancia) return;
  const pronto = await carregarIdioma(instancia, codigo);
  definirIdioma(pronto ? codigo : 'en');
};
